/** The UI and email webhook must resolve the same operator-owned domain. */
export function getAssistantEmailDomain(
  configuredDomain = process.env.NEXT_PUBLIC_AZIMUT_AGENT_EMAIL_DOMAIN,
  appUrl = process.env.NEXT_PUBLIC_DUST_APP_URL || "https://getazimut.com",
): string {
  return configuredDomain?.trim().toLowerCase() || new URL(appUrl).hostname;
}

export const ASSISTANT_EMAIL_SUBDOMAIN = getAssistantEmailDomain();
